import { init } from "../init";
import { FourOhFourPage } from "../pages/404-page";

init(FourOhFourPage);
